import { useLocation } from "react-router-dom";

export default function useUrlParams(decodeSearch = false) {
	let search = useLocation().search;

	if(decodeSearch){
		search = decodeURIComponent(search);
	}

	return new URLSearchParams(search);
}
